import { Component, Input, forwardRef } from '@angular/core';
import { DashboardBaseComponent } from '../shared/dashboard-base-component';

export interface MetricaItem {
  label: string;
  value: string;
  porcentaje: number;
  color: string;
  labelColor?: string;
  porcentajeLabel?: string;
}

export interface ListaMetricasConfig {
  items: MetricaItem[];
  total?: {
    label: string;
    value: string;
    porcentajeLabel: string;
  };
}

export interface ListaMetricasCardConfig {
  title: string;
  sub?: string;
  chart?: ListaMetricasConfig;
}

@Component({
  selector: 'app-lista-metricas',
  templateUrl: './lista-metricas.component.html',
  styleUrls: ['./lista-metricas.component.scss'],
  standalone:true,
  providers: [
    {
      provide: DashboardBaseComponent,
      useExisting: forwardRef(() => ListaMetricasComponent)
    }
  ]
})
export class ListaMetricasComponent extends DashboardBaseComponent {
  private _config!: ListaMetricasConfig;

  @Input() set config(val: ListaMetricasConfig) {
    this._config = val;
    if (val?.items) this.isLoaded = true;
  }
  get config() { return this._config; }

  get items() { return this._config.items ?? []; }

}
